import styled from 'foundations-theming/utils';
export const ErrorMessage = styled.div.withConfig({
  displayName: "ErrorMessage",
  componentId: "anbaje-0"
})(["font-size:12px;text-align:center;margin-top:10px;color:#425b76;"]);